// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bfu_a"};